import React, { Component } from 'react'
import { compose, graphql, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { translate } from 'react-i18next'
import ALL_ACTIVITY_LOCATIONS from './../graphql/HomePage/AllActivityLocations.graphql'
import ALL_TOURS_DESTINATIONS_QUERY from './../graphql/HomePage/AllToursDestinations.graphql'
import ALL_TRIP_GURUS from './../graphql/HomePage/AllTripGurus.graphql'
import ALL_RECENTLY_BOOKED_QUERY from './../graphql/HomePage/AllRecentlyBooked.graphql'
import ALL_FEATURED_DESTINATIONS from './../graphql/HomePage/AllFeaturedDestinations.graphql'
import ALL_AVAILABLE_LOCATIONS from './../graphql/HomePage/AllAvailableLocations.graphql'
import { AllActivities, ComplexSearch, Footer, GuidedActivities, TripGuru } from './homepage'
import { Loader } from './UI'

// const clientId = 'yQzgZwrLdHHdNE0x9gxrzFRkhSgcIC7z'
// const domain='trippere.auth0.com'
// Secret -3iOGSiyH-T423Xa3Fpg-rLj_-IKw-u-PtkuZrgl2lQRIa6zCByIjZsawPP5MGAH

class MainPage extends Component {
  constructor() {
    super()
    this.state = {
      activeSection: 1,
      guruLocations: [],
      selectedCountry: false
    }
  }

  shouldComponentUpdate = props => {
    return !!(
      !props.localTours.loading &&
      !props.allGurus.loading &&
      !props.recentlyBooked.loading &&
      !props.featuredDestinations.loading &&
      !props.allActivityLocations.loading &&
      !props.allAvailableLocations.loading
    )
  }

  renderSection(props) {
    switch (this.state.activeSection) {
      case 1: {
        return (
          <AllActivities
            localTours={props.allActivityLocations}
            tripGurus={props.allGurus}
            recentlyBooked={props.recentlyBooked}
            featuredDestinations={props.featuredDestinations}
            selectedCountry={this.state.selectedCountry}
          />
        )
      }
      case 2: {
        return (
          <GuidedActivities
            localTours={props.allActivityLocations}
            recentlyBooked={props.recentlyBooked}
            featuredDestinations={props.featuredDestinations}
            selectedCountry={this.state.selectedCountry}
          />
        )
      }
      case 3: {
        return (
          <TripGuru
            tripGurus={props.allGurus}
            recentlyBooked={props.recentlyBooked}
            featuredDestinations={props.featuredDestinations}
            selectedCountry={this.state.selectedCountry}
          />
        )
      }
    }
  }

  changeActiveSection = indexSelection => {
    this.setState({ activeSection: parseInt(indexSelection) })
  }

  render() {
    const { t, recentlyBooked, localTours, allGurus, featuredDestinations, allAvailableLocations, allActivityLocations } = this.props

    if (
      recentlyBooked.loading ||
      localTours.loading ||
      allGurus.loading ||
      featuredDestinations.loading ||
      allAvailableLocations.loading ||
      allActivityLocations.loading
    ) {
      return <Loader showLoader={true} />
    } else
      return (
        <div className="site-container homepage">
          <div className="jumbotron-wrapper">
            <div className="jumbotron container">
              <h1>{t('main_title')}</h1>
              <h3>{t('main_description')}</h3>
              <ComplexSearch
                allAvailableLocations={allAvailableLocations.allLocations}
                tripGurus={allGurus.allUsers}
                allActivityLocations={allActivityLocations}
                changeActiveSection={this.changeActiveSection}
                currentActiveSection={this.state.activeSection}
                handleChangeCountry={() => this.setState({ selectedCountry: true })}
                handleClearCountry={() => this.setState({ selectedCountry: false })}
              />
            </div>
          </div>

          <nav className="navbar navbar-default">
            <div className="container-fluid">
              <ul className="nav navbar-nav">
                <li className={this.state.activeSection === 1 ? 'active' : ''}>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault()
                      this.setState({ activeSection: 1 })
                    }}
                  >
                    {t('all_for_you')}
                  </a>
                </li>
                <li className={this.state.activeSection === 2 ? 'active' : ''}>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault()
                      this.setState({ activeSection: 2 })
                    }}
                  >
                    {t('guided_activities')}
                  </a>
                </li>
                <li className={this.state.activeSection === 3 ? 'active' : ''}>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault()
                      this.setState({ activeSection: 3 })
                    }}
                  >
                    {t('guru_tailored_tours')}
                  </a>
                </li>
              </ul>
            </div>
          </nav>
          {this.renderSection(this.props)}

          <Footer />
        </div>
      )
  }
}

export default compose(
  //graphql(ALL_CUSTOMIZED_PLANS_QUERY, { name: 'customizedPlans' }),
  graphql(ALL_TRIP_GURUS, { 
      name: 'allGurus',
      options: {
        variables: {
          approvalStatus: 'Approved'
        }
      }
  }),
  graphql(ALL_RECENTLY_BOOKED_QUERY, { name: 'recentlyBooked' }),
  graphql(ALL_TOURS_DESTINATIONS_QUERY, {
    name: 'localTours',
    options: {
      variables: {
        activityStatus: 'InProgress'
      }
    }
  }),
  // graphql(ALL_LOCATIONS_GURU, {name: 'allLocationsGuru'}),
  graphql(ALL_ACTIVITY_LOCATIONS, { name: 'allActivityLocations' }),
  graphql(ALL_FEATURED_DESTINATIONS, {
    name: 'featuredDestinations',
    options: {
      variables: {
        isFeaturing: true
      }
    }
  }),
  graphql(ALL_AVAILABLE_LOCATIONS, { name: 'allAvailableLocations' })
)(withRouter(withApollo(translate('main')(MainPage))))



// WEBPACK FOOTER //
// src/components/MainPage.jsx